module.exports = __webpack_public_path__ + "img/cross.54c4323e.svg";